/**
* In this file use to contains the physician Module Appointments calendar screen UI and Logic
**/
import { goBack } from '../../services/UtilsService';
import { Link } from 'react-router-dom';
import {useState,useEffect} from 'react';
import ApiService from '../../services/ApiService';
import { appointmentEventdates } from '../../services/UtilsService';
import FullCalendar from '@fullcalendar/react';
import allLocales from '@fullcalendar/core/locales-all';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import AppointmentCalendarCancelModal from '../modals/AppointmentCalendarCancelModal';
import { useTranslation } from 'react-i18next';

function Appointments(){
	
	//Intial state declaration
   const [params ,setParams]=useState({sort:'all'});
   const [data ,setData]=useState([]);
   const role = Number(localStorage.getItem('role'));
   const locale = localStorage.getItem('i18nextLng') || 'en';
   const [showCancelModal, setShowCancelModal] = useState(false);
   const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);   
   const [currentView, setCurrentView] = useState('customMonthView'); // Default to month view
   const [user, setUser] = useState([]);
   const { t } = useTranslation();

   //Component initialize function
   	useEffect(()=>{
	   (async()=>{
		   	if(Object.keys(params).length ===3){
		     	var response = await ApiService.getAppointmentCalendarList(params);
				var userResponse = await ApiService.getUsersList({ list: ['hospital', 'parent','physician','physician_mapping','parent_mapping'] });
				if(userResponse.status===200)
					setUser(userResponse.data);
			 	if(response.status===200){
					var events = response.data.items.map(i=>{
						// Update the title based on role
						const title = role === 4 ? `${i.physician_name} - ${i.member_name}` : i.member_name;
						return {...{title:title,id:i.id,member:i.member,physician:i.physician,created_by:i.created_by,mapping:i.mapping,parent_physician_mapping:i.parent_physician_mapping},...appointmentEventdates(i.time)};
					});
					setData(events);
					console.log("DATA ",data );
				}
		   	}
	   })();
  	},[params,role]);
   
   /** 
   * To handle the drag event for update appointment
   * @event we get the events details from the drop function
   **/
	/* const handleEventDrop = async({ event }) => {
		//To avoid update for past date
		if(new Date()>= event.start || event.extendedProps.mapping===false || new Date() > new Date(event.extendedProps.prevStart)){
			event.setStart(event.extendedProps.prevStart);
		    event.setEnd(event.extendedProps.prevEnd);
		}else{
			var data={};
			data.date=event.start;
			data.time=event.start;
			data.id=event.id;
			data.member=event.extendedProps.member;
			data.physician=event.extendedProps.physician;
			data.created_by=event.extendedProps.created_by;		
			var response = await ApiService.updateAppointment(data);
			if(response.status===200){
				setParams({...params});		
			}
		}
    } */
	
	/** 
	* To handle filter change
	* @e we get the onChange function's event details
	**/
	const handleChange=(value)=>async(e)=>{
		setParams(params=>({...params,sort:value}));
	}
    
	/** 
	* To capture start and end date
	* @event we get the datesSet events details
	**/
    const handleDatesSet=(event)=>{
		 setCurrentView(event.view.type); // Track the active view type
		 const { start, end } = event;
         setParams(params=>({...params,startDate:start,endDate:end}));
	}

	const renderEventWithCancel = (arg) => {
		console.log("ARG : ",arg);

		// Find the specific event data in the `data` array
		const eventData = data.find(event => event.id === arg.event.id);

		// Only show the "Cancel" button in List Views (Week and Day views)
		if (currentView === 'customMonthView') {
			// For Month View, no cancel button
			return (
				<div>
					<span>
						{arg.timeText}
					</span>
					<span>&nbsp;</span>
					<span className="text-capitalize">{arg.event.title}</span>
				</div>
			);
		}

		// Check if the event is in the past using the end date of the event
		const eventStartDate = new Date(arg.event.startStr); // Convert the startStr to a Date object
		const currentDate = new Date(); // Get the current date/time

		// If the event has already ended, do not show the "Cancel" button
		if (eventStartDate < currentDate) {
			return (
				<div style={{ display: 'flex' }}>
					<div>
						<span className="text-capitalize">{arg.event.title}</span>
						<span>
							{arg.timeText}
						</span>
					</div>
				</div>
			);
		}

		// For Week and Day views, show the "Cancel" button if the event is not in the past
		// and if data.parent_physician_mapping is true
	    if (eventData && eventData.parent_physician_mapping) {
			return (
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<div style={{ display: 'flex', flexDirection: 'column' }}>
						<span className="text-capitalize">{arg.event.title}</span>
						<span>
							{arg.timeText}
						</span>
					</div>
					<div>
						<button
							className={`${role === 4 ? 'btn-tmAquaGreen' : 'btn-primary'} btn btn-sm rounded-pill`}
							onClick={() => {
								setSelectedAppointmentId(arg.event.id); // Store the appointment ID
								setShowCancelModal(true); // Open modal
							}}
						>
							{t('common.cancel')}
						</button>
					</div>
				</div>
			);
		}

		// If data.parent_physician_mapping is false, do not show the Cancel button
		return (
			<div style={{ display: 'flex' }}>
				<div>
					<span className="text-capitalize">{arg.event.title}</span>
					<span>
						{arg.timeText}
					</span>
				</div>
			</div>
		);
	};
	
	return (
	<main id="main" className="main">
	{showCancelModal && (
		<AppointmentCalendarCancelModal
			show={showCancelModal}
			onHide={() => setShowCancelModal(false)} // Close modal on hide
			appointmentId={selectedAppointmentId} // Pass selected appointment ID
			onCancelSuccess={() => {
				setParams({ ...params }); // Refresh appointments if needed
				setShowCancelModal(false); // Close modal
			}}
		/>
	)}
	{/* Page Title Section*/}
		<div className="pagetitle clearfix">
			<div className="float-start">
			  <h1>{t('sidebar.appointments')}</h1>
				<nav>
					<ol className="breadcrumb">
					  <li className="breadcrumb-item"><Link to={window.location.href.includes('hospital/admin') ? "/hospital/admin/dashboard" : "/physician/dashboard"}>{t('sidebar.home')}</Link></li>					  
					  <li className="breadcrumb-item active">{t('sidebar.appointments')} </li>
					</ol>
				</nav>
			</div>
			<div className="float-end mt-2 me-1">
				<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
			</div>
		</div>
		{/*End Page Title Section*/}
		
		{/*End Page Content Section*/}
		<section className="pagesection">
		{/*Appointments*/}
			<div className="row">
				<div className="col-12">
					<div className="container">				  
						<div className={`row my-4 calendar-sec ${role === 4 ? 'adminCalendar-sec' : ''}`}>
							<div className="col-lg-10 col-md-9">
						 <FullCalendar
							plugins={[dayGridPlugin, interactionPlugin,listPlugin]}
							locales={allLocales}
  							locale={locale} 
							initialView="customMonthView"
							headerToolbar={{
							  left: 'prev,next',
							  center: 'title',
							  right: 'customDayView,customWeekView,customMonthView'
							}}
							datesSet={handleDatesSet}
							views={{
								customMonthView: {
								  type: 'dayGridMonth',
								  buttonText: t('common.month'),
								},
								customWeekView: {
								  type: 'listWeek',
								  buttonText: t('common.listWeek'),
								},
								customDayView: {
								  type: 'listDay',
								  buttonText: t('common.listDay'),
								},
						      }}
							 editable={false} //editable={true} To Enable event dragging and resizing
							 //eventDrop={handleEventDrop} // Event drop handler
							 droppable={false}//droppable={true}
							 dayMaxEventRows={true} // Enable event limit
							 dayMaxEvents={3}
						     events={data}
							 eventTimeFormat={{
								hour: 'numeric',
								minute: '2-digit',
								meridiem: 'uppercase'
							}}
							eventContent={(arg) => renderEventWithCancel(arg)} // Add custom rendering 'Cancel' button
							navLinks = {true}
							selectable ={true}
						/>
							
							</div>
							<div className="col-lg-2 col-md-3">
								<div className="title">
									<h6 className="mb-0">{t('common.filter')}</h6>
								</div>
								<div className="form-check mt-3 ms-1">
								  <input className="form-check-input" checked={params?.sort==='all'?true:false}type="checkbox" value="" id="flexCheckDefault1" onChange={handleChange('all')} />
								  <label className="form-check-label" >
									{t('common.viewAll')}
								  </label>
								</div>
								<div className="form-check danger mt-3 ms-1">
								  <input className="form-check-input" checked={params?.sort==='past'?true:false} type="checkbox" value="" id="flexCheckDefault2"  onChange={handleChange('past')}/>
								  <label className="form-check-label" >
									{t('common.past')}
								  </label>
								</div>
								<div className="form-check success mt-3 ms-1">
								  <input className="form-check-input" checked={params?.sort==='upcoming'?true:false} type="checkbox" value="" id="flexCheckDefault3" onChange={handleChange('upcoming')} />
								  <label className="form-check-label" >
									{t('common.upcoming')}
								  </label>
                            </div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/*End Appointments*/}
			
		</section>
		{/*End Page Content Section*/}
		</main>
	);
}
export default Appointments;
